import React from 'react'
import FactorListContainer from '../../../../Components/Factor/FactorListContainer/FactorListContainer'
import Layout from '../../Layout'

const FactorList = () => {
  return (
    <Layout><FactorListContainer/></Layout>
  )
}

export default FactorList